import type { ApiResponseErrors } from "ui/util/api/ApiResponse";

export const useCsrfCookie = (url: string) => useState(
  'csrf-cookie',
  () => useFetch<unknown, ApiResponseErrors>(
    url,
    {
      server: false,
      credentials: 'include',
    },
  ),
);



